import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';

const styles = (theme) => {
  const {
    palette: {
      common: { white },
    },
    spacing: { unit },
    zIndex: { tooltip },
  } = theme;

  return {
    fade: {
      borderRadius: 0,
      maxHeight: 394,
      maxWidth: 297,
      overflowY: 'auto',
    },
    paper: {
      backgroundColor: white,
      padding: unit,
    },
    popper: {
      cursor: 'default',
      zIndex: tooltip,
    },
  };
};

class MenuContainer extends PureComponent {
  handleClickAway = () => {
    const { onClickAway } = this.props;

    if (onClickAway) {
      const dispatcher = debounce(onClickAway, 100);

      dispatcher();
    }
  };

  render() {
    const {
      children,
      classes,
      className,
      classNameFade,
      classNamePaper,
      elevation,
      menuAnchor,
      placement,
      fadeStyle,
      disablePortal,
    } = this.props;

    return (
      <Popper
        anchorEl={menuAnchor}
        className={classnames(classes.popper, className)}
        disablePortal={disablePortal}
        modifiers={{
          flip: {
            enabled: true,
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: 'scrollParent',
          },
        }}
        open={Boolean(menuAnchor)}
        placement={placement || 'bottom'}
        transition
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={this.handleClickAway}>
            <Fade
              className={classnames(classes.fade, classNameFade)}
              style={fadeStyle}
              timeout={100}
              {...TransitionProps}
            >
              <Paper className={classnames(classes.paper, classNamePaper)} elevation={elevation || 2}>
                {children}
              </Paper>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    );
  }
}

MenuContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classNameFade: PropTypes.string,
  classNamePaper: PropTypes.string,
  classes: PropTypes.object.isRequired,
  disablePortal: PropTypes.bool,
  elevation: PropTypes.number,
  fadeStyle: PropTypes.object,
  menuAnchor: PropTypes.object,
  onClickAway: PropTypes.func,
  placement: PropTypes.string,
};

MenuContainer.defaultProps = {
  className: '',
  classNameFade: '',
  classNamePaper: '',
  elevation: 2,
  menuAnchor: null,
  placement: '',
  fadeStyle: {},
};

export default withStyles(styles)(MenuContainer);
